class ProductDetailsSticky extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains('sticky-content--desktop')) return;

    this.updateHeight = this.updateHeight.bind(this);
    this.resizeObserver = new ResizeObserver(this.updateHeight);
    this.resizeObserver.observe(this);
    window.addEventListener('resize', this.updateHeight, { passive: true });
    this.updateHeight();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.updateHeight);
  }

  updateHeight() {
    this.style.setProperty('--product-details-sticky-height', `${this.getBoundingClientRect().height}px`);
  }
}

if (!customElements.get('product-details-sticky')) {
  customElements.define('product-details-sticky', ProductDetailsSticky);
}
